import { colors, fontSize, size } from '@styles/theme'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'

import { TbAlertTriangle, TbBan, TbMapPin, TbNews, TbTrash } from 'react-icons/tb'
import { Button, ButtonBase } from '@mui/material'
import { PiArrowLeftBold } from 'react-icons/pi'

const DrawerButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #333333;
  border-color: rgba(255,255,255, 0.15) !important;
  height: ${size(5.5)};
  border-radius: 20px;
  font-size: ${fontSize('sm')};
`

// Drawer Close Button
const CloseButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  // font-size: ${fontSize('sm')};
  // height: ${size(4)};
  font-size: ${fontSize('xs')};
  height: ${size(3.5)};
  padding: 0 ${size(1.25)};
  background-color: #333333;
  border: 0.5px solid rgba(255,255,255, 0.15) !important;
  border-radius: 100px;
`

const DrawerCloseButton = ({ setClosed, ...rest }) => {
  return (
    <CloseButton onClick={setClosed} {...rest}>
      <PiArrowLeftBold />
      &nbsp;Back&nbsp;
    </CloseButton>
  )
}


const NearbyProfileButton = ({ user, isOnNearbyProfile=false, ...rest }) => {
  const navigate = useNavigate()

  const navigateToProfile = () => {
    if (isOnNearbyProfile) {
      navigate(-1)
    } else {
      navigate(`/map?screen_modal=nearby-profile&nearby_uuid=${user?.nearbyUuid}`, { replace: true })
    }
  }

  return (
    <DrawerButton
      onClick={navigateToProfile}
      {...rest}>
      Nearby Profile<TbMapPin color='lightgrey' size={size(2.5)} />
    </DrawerButton>
  )
}

const SocialProfileButton = ({ user, isOnSocialProfile=false, ...rest }) => {
  const navigate = useNavigate()

  const navigateToProfile = () => {
    if (isOnSocialProfile) {
      navigate(-1)
    } else {
      // TODO: add in location state later
      navigate(`/profiles/${user?.uuid}`, { replace: true })
    }
  }

  return (
    <DrawerButton
      onClick={navigateToProfile}
      {...rest}>
      Social Profile<TbNews color='lightgrey' size={size(2.5)} />
    </DrawerButton>
  )
}

const BlockButton = ({ ...rest }) => {
  return (
    <DrawerButton {...rest}>
      Block User<TbBan color={colors.error(200)} size={size(2.5)} />
    </DrawerButton>
  )
}

const ReportButton = ({ text='Report User', ...rest }) => {
  return (
    <DrawerButton {...rest}>
      {text}<TbAlertTriangle color={colors.tertiary(300)} size={size(2.5)} />
    </DrawerButton>
  )
}

const DeleteConversationButton = ({ ...rest }) => {
  return (
    <DrawerButton {...rest}>
      Delete Conversation<TbTrash color='lightgrey' size={size(2.5)} />
    </DrawerButton>
  )
}

const DeletePostButton = ({ ...rest }) => {
  return (
    <DrawerButton {...rest}>
      Delete Post<TbTrash color='lightgrey' size={size(2.5)} />
    </DrawerButton>
  )
}

export {
  DrawerButton,
  DrawerCloseButton,
  NearbyProfileButton,
  SocialProfileButton,
  BlockButton,
  ReportButton,
  DeleteConversationButton,
  DeletePostButton,
}
